<template>
  <div class="cross-section-dashboard">
    <div class="charts-grid">
      <!-- Tubing Charts -->
      <template v-if="crossSectionData?.tubingChartSet">
        <div
          v-for="(tubingDataSet, index) in crossSectionData.tubingChartSet"
          :key="`tubing-cs-${index}`"
          class="chart-cell"
        >
          <CrossSectionChart
            :title="tubingDataSet.title"
            :chart-data="tubingDataSet.chartSet"
            :small-length-unit="smallLengthUnit"
          />
        </div>
      </template>
      <!-- Y Block Charts -->
      <div v-if="crossSectionData?.yToolChart" class="chart-cell">
        <CrossSectionChart
          title="Y Block"
          :chart-data="crossSectionData.yToolChart"
          :small-length-unit="smallLengthUnit"
        />
      </div>
      <!-- Bolt On Discharge Chart -->
      <div v-if="crossSectionData?.boltOnDischargeChart" class="chart-cell">
        <CrossSectionChart
          title="Bolt On Discharge"
          :chart-data="crossSectionData.boltOnDischargeChart"
          :small-length-unit="smallLengthUnit"
        />
      </div>
      <!-- Pump Charts -->
      <template v-if="crossSectionData?.pumpChartSet">
        <div
          v-for="(pumpDataset, index) in crossSectionData.pumpChartSet"
          :key="`pump-cs-${index}`"
          class="chart-cell"
        >
          <CrossSectionChart
            :title="`Pump ${index + 1}`"
            :chart-data="pumpDataset"
            :small-length-unit="smallLengthUnit"
          />
        </div>
      </template>

      <!-- Intake Charts -->
      <template v-if="crossSectionData?.intakeChartSet">
        <div
          v-for="(intakeDataset, index) in crossSectionData.intakeChartSet"
          :key="`intake-cs-${index}`"
          class="chart-cell"
        >
          <CrossSectionChart
            :title="`Intake ${index + 1}`"
            :chart-data="intakeDataset"
            :small-length-unit="smallLengthUnit"
          />
        </div>
      </template>

      <!-- Seal Charts -->
      <template v-if="crossSectionData?.sealChartSet">
        <div
          v-for="(sealDataset, index) in crossSectionData.sealChartSet"
          :key="`seal-cs-${index}`"
          class="chart-cell"
        >
          <CrossSectionChart
            :title="`Seal ${index + 1}`"
            :chart-data="sealDataset"
            :small-length-unit="smallLengthUnit"
          />
        </div>
      </template>

      <!-- Motor Chart -->
      <div v-if="crossSectionData?.motorChart" class="chart-cell">
        <CrossSectionChart
          title="Motor"
          :chart-data="crossSectionData.motorChart"
          :small-length-unit="smallLengthUnit"
        />
      </div>

      <!-- Sensor Chart -->
      <div v-if="crossSectionData?.sensorChart" class="chart-cell">
        <CrossSectionChart
          title="Sensor"
          :chart-data="crossSectionData.sensorChart"
          :small-length-unit="smallLengthUnit"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CrossSectionChart from "./CrossSectionChartSingle.vue";
import type { CrossSectionChartData } from "@/libs/charting/crossSection";
import type { ConvertableUnit } from "@/libs/units";
import { computed } from "vue";

const props = defineProps<{
  title: string;
  crossSectionData: CrossSectionChartData;
  smallLengthUnit: ConvertableUnit;
}>();

const equipmentLabel = computed(() => {
  if (props.title === "top") {
    return "Top Equipment";
  }
  if (props.title === "bottom") {
    return "Bottom Equipment";
  } else {
    return "";
  }
});
</script>

<style lang="scss" scoped>
.cross-section-dashboard {
  max-width: 2070px;
  .dashboard-title {
    justify-self: center;
  }
}

.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
}

.chart-cell {
  width: 800px;
  &:nth-child(odd) {
    justify-self: start;
  }
  &:nth-child(even) {
    justify-self: end;
  }
}

@media only screen and (max-width: 1920px) {
  .chart-cell {
    width: 650px;
  }
}

@media only screen and (max-width: 1850px) {
  .chart-cell {
    width: 600px;
  }
}

@media only screen and (max-width: 1338px) {
  .chart-cell {
    width: 550px;
  }
}

@media only screen and (max-width: 1197px) {
  .charts-grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .chart-cell {
    width: 800px;
    justify-self: center !important;
  }
}

@media only screen and (max-width: 820px) {
  .chart-cell {
    width: 600px;
  }
}
@media only screen and (max-width: 766px) {
  .dashboard-title {
    text-align: center;
  }
}
</style>
